import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class WorkCalendarService {
  /**
   * Work shedule
   * @param id
   * @returns
   */
  static getWorkShedule = async (id: number) => {
    try {
      return await Http.get(
        `${API_URLs.settings.workCalendar.workShedule.getOneTime}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static getWorkShedules = async () => {
    try {
      return await Http.get(
        `${API_URLs.settings.workCalendar.workShedule.getOneTime}?type=SPECIFIC`
      );
    } catch (error) {
      return error;
    }
  };

  static postWorkShedules = async (data: any) => {
    try {
      return await Http.post(
        `${API_URLs.settings.workCalendar.workShedule.getOneTime}`,
        data
      );
    } catch (error) {
      return error;
    }
  };

  static patchWorkShedule = async (data: any) => {
    try {
      return await Http.patch(
        API_URLs.settings.workCalendar.workShedule.patchTime,
        data
      );
    } catch (error) {
      return error;
    }
  };

  static deleteWorkShedule = async (id: number) => {
    try {
        return await Http.delete(`${API_URLs.settings.workCalendar.workShedule.deleteTime}`, id)
    } catch (error) {
        return error;
    }
}

  /** End Work shedule */

  static getHolydays = async (params?: any) => {
    try {
      return await Http.get(
        API_URLs.settings.workCalendar.publicHolidays.getHolidays,
        params
      );
    } catch (error) {
      return error;
    }
  };

  static createHoliday = async (data: any) => {
    try {
      return await Http.post(
        API_URLs.settings.workCalendar.publicHolidays.createHoliday,
        data
      );
    } catch (error) {
      return error;
    }
  };

  static getOneHolyday = async (id: number) => {
    try {
      return Http.get(
        `${API_URLs.settings.workCalendar.publicHolidays.getOneHoliday}/${id}`
      );
    } catch (error) {
      return error;
    }
  };

  static patchHoliday = async (data: any) => {
    try {
      return await Http.patch(
        API_URLs.settings.workCalendar.publicHolidays.patchHoliday,
        data
      );
    } catch (error) {
      return error;
    }
  };

  static deleteHoliday = async (id: number) => {
    try {
      return await Http.delete(
        API_URLs.settings.workCalendar.publicHolidays.deleteHoliday,
        id
      );
    } catch (error) {
      return error;
    }
  };
}
